module.exports = __webpack_public_path__ + "img/Wp_2006.bd8539a3.png";